import React, { useEffect, useState } from "react";
import FilterBar from "../../../components/common/FilterBar";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";

// Charges Master filters (used by both Charges Master pages): rate card,
// category and express type on the page instead of the pop-up.

// The categories the charges fetch accepts (its source @Pattern)
const CATEGORY_OPTIONS = [
  { value: "WITHIN_CITY", label: "Within City" },
  { value: "WITHIN_ZONE", label: "Within Zone" },
  { value: "WITHIN_METRO", label: "Within Metro" },
  { value: "REST_OF_INDIA", label: "Rest of India" },
  { value: "SPECIAL_INDIA", label: "Special India" },
];

const EXPRESS_OPTIONS = [
  { value: "AIR", label: "Air" },
  { value: "SURFACE", label: "Surface" },
];

const ChargeFilterBar = ({ filters, onChange, refreshKey }) => {
  const [rateCards, setRateCards] = useState([]);

  // Rate card names can change in the Rate Cards pop-up, so reload on refreshKey
  useEffect(() => {
    axiosPostApi(`${apiList.FETCH_RATE_CARD_MASTER}?&pageSize=1000&pageNo=1`, {
      username: sessionStorage.getItem("username"),
    })
      .then((response) => {
        if (response?.data?.respCode === "00") {
          setRateCards(
            (response.data.data || []).map((rc) => ({
              value: rc.rateCardId,
              label: rc.rateCardName ? `${rc.rateCardName} (${rc.rateCardId})` : rc.rateCardId,
            })),
          );
        }
      })
      .catch(() => setRateCards([]));
  }, [refreshKey]);

  return (
    <FilterBar
      values={filters}
      onChange={onChange}
      selects={[
        ...(rateCards.length
          ? [{ key: "rateCardId", allLabel: "All rate cards", chipLabel: "Rate card", options: rateCards }]
          : []),
        { key: "source", allLabel: "All categories", chipLabel: "Category", options: CATEGORY_OPTIONS },
        { key: "express", allLabel: "Air and surface", chipLabel: "Express", options: EXPRESS_OPTIONS },
      ]}
    />
  );
};

export default ChargeFilterBar;
